function VideoCallIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-blue-500 scale-[65%]"
      fill="transparent"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
      viewBox="0 0 24 24"
    >
      <path d="M23 7L16 12 23 17 23 7z"></path>
      <rect width="15" height="14" x="1" y="5" rx="2" ry="2"></rect>
    </svg>
  );
}

export default VideoCallIcon;
